// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {PageTitle} from '~/GalleryPB/PageTitle';
import {Link} from '~library/atoms/Link';
import {Picture} from '~library/atoms/Picture';

export const NoFavorites = () => (
  <>
    <PageTitle text="My favorites" numTemplates={0} />
    <div className="woo-hooman__wrapper">
      <Picture
        className="woo-hooman"
        alt=""
        srcSet={[
          '/assets/images/illustrations/woohooman.avif',
          '/assets/images/illustrations/woohooman.mp4',
          '/assets/images/illustrations/woohooman.gif',
        ]}
      />
      <p className="gallery-link">
        You haven't favorited any designs yet. Check out{' '}
        <Link href="/gallery" data-qa-id="galleryNoFavoritesFeaturedLink">
          these new and trending invitations
        </Link>{' '}
        to start your list!
      </p>
    </div>
  </>
);
